import React, { useState, useEffect } from 'react';

function LapJBM() {
  const [LapPasangData, setLapPasangData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [listTransaksi, setListTransaksi] = useState([]);
  const [jnsKendaraan, setJnsKendaraan] = useState('');
  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [loading, setLoading] = useState(false); 
  const schema = localStorage.getItem('schema');

  const today = new Date();

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    return date.toISOString().split('T')[0];
  };  
  const [start_date, setStartDate] = useState(formatDate(today));

  const numericKeys = [
    'RIT',
    'JML_POIN',
  ];

  const columns = [
    'KD_KENDARAAN',
    'NOPOL',
    'SOPIR',
    'RIT',
    'JML_POIN',
    'A_01', 'A_02', 'A_03', 'A_04', 'A_05', 'A_06', 'A_07', 'A_08', 'A_09', 'A_10',
    'A_11', 'A_12', 'A_13', 'A_14', 'A_15', 'A_16', 'A_17', 'A_18', 'A_19', 'A_20',
    'A_21', 'A_22', 'A_23', 'A_24', 'A_25', 'A_26', 'A_27', 'A_28', 'A_29', 'A_30', 'A_31',   
  ];

const columnLabels = {
  KD_KENDARAAN: 'KODE',
  NOPOL: 'NOPOL',
  SOPIR: 'SOPIR',
  RIT: 'RIT',
  JML_POIN: 'POIN',
  A_01: '01', A_02: '02', A_03: '03', A_04: '04', A_05: '05', A_06: '06', A_07: '07', A_08: '08', A_09: '09', A_10: '10',
  A_11: '11', A_12: '12', A_13: '13', A_14: '14', A_15: '15', A_16: '16', A_17: '17', A_18: '18', A_19: '19', A_20: '20',
  A_21: '21', A_22: '22', A_23: '23', A_24: '24', A_25: '25', A_26: '26', A_27: '27', A_28: '28', A_29: '29', A_30: '30', A_31: '31',
};

const columnWidths = {
  KD_KENDARAAN: '50px',
  NOPOL: '80px',
  SOPIR: '100px',
  RIT: '50px',
  JML_POIN: '60px',
  A_01: '200px', A_02: '200px', A_03: '200px', A_04: '200px', A_05: '200px', 
  A_06: '200px', A_07: '200px', A_08: '200px', A_09: '200px', A_10: '200px',
  A_11: '200px', A_12: '200px', A_13: '200px', A_14: '200px', A_15: '200px',
  A_16: '200px', A_17: '200px', A_18: '200px', A_19: '200px', A_20: '200px',
  A_21: '200px', A_22: '200px', A_23: '200px', A_24: '200px', A_25: '200px',
  A_26: '200px', A_27: '200px', A_28: '200px', A_29: '200px', A_30: '200px', A_31: '200px',
};


  const formatNumber = (value) =>
    isNaN(value) ? value : new Intl.NumberFormat('id-ID').format(Number(value));

  const fetchPilihanTransaksi = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/lap_jbm.php?caller=pilih_kend&schema=${schema}`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setListTransaksi(data);
        if (data.length > 0) {
          setJnsKendaraan(data[0].JNS_KENDARAAN);  
        }
      }
    } catch (error) {
      alert('Gagal memuat pilihan transaksi');
    }
  };

const fetchLapPasangData = async () => {
  if (!jnsKendaraan) return;
  try {
    setLoading(true);  
    const url = `${process.env.REACT_APP_API_BASE_URL}/lap_jbm.php?caller=isi_jbm&schema=${schema}&jns_kendaraan=${jnsKendaraan}&start_date=${start_date}`;
    const response = await fetch(url);
    const data = await response.json();
    if (Array.isArray(data)) {
      setLapPasangData(data);
      setFilteredData(data);
    } else {
      throw new Error('Data tidak valid');
    }
  } catch (error) {
    alert('Gagal memuat data');
  } finally {
    setLoading(false); 
  }
};


  useEffect(() => {
    fetchPilihanTransaksi();
  }, []);

  useEffect(() => {
    fetchLapPasangData();
  }, [jnsKendaraan]);

  useEffect(() => {
    let filtered = LapPasangData.filter((item) =>
      Object.keys(filters).every((key) =>
        filters[key] === '' || String(item[key] ?? '').toLowerCase().includes(filters[key].toLowerCase())
      )
    );
    setFilteredData(filtered);
  }, [filters, LapPasangData]);

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });

    const sorted = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sorted);
  };

  const getSortIcon = (key) =>
    sortConfig.key === key ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '';

  return (
    <div>
      <div className="section-header">
        <h2>Jadwal Bongkar Muat</h2>
        <div className="responsive-filter">
          <label>Pilih: </label>
          <input type="date" value={start_date} onChange={(e) => setStartDate(e.target.value)} />
          <select
            value={jnsKendaraan}
            onChange={(e) => setJnsKendaraan(e.target.value)}
          >
            {listTransaksi.map((item, idx) => (
              <option key={idx} value={item.JNS_KENDARAAN}>
                {item.JNS_KENDARAAN}
              </option>
            ))}
          </select>
          <button
            onClick={fetchLapPasangData}
            disabled={loading}
            style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? 'Loading...' : 'Refresh'}
          </button>
        </div>
      </div>

      <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '0 0 10px 10px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', maxHeight: '80vh' }}>
        <table className="responsive-table" style={{ fontSize: '14px', tableLayout: 'fixed' }}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col}
                  onClick={() => handleSort(col)}
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    textAlign: 'center',
                    cursor: 'pointer',
                    width: columnWidths[col] || 'auto',
                  }}
                >
                  {columnLabels[col] || col} {getSortIcon(col)}
                </th>
              ))}
            </tr>
            <tr>
              {columns.map((col) => (
                <th key={`filter-${col}`}
                  style={{
                    position: 'sticky',
                    top: 40,
                    zIndex: 1,
                  }}
                >
                  <input
                    type="text"
                    placeholder="Filter..."
                    style={{ width: '90%' }}
                    onChange={(e) => setFilters({ ...filters, [col]: e.target.value })}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, idx) => (
                <tr key={idx}>
                  {columns.map((key) => (
                    <td
                      key={key}
                      style={{ textAlign: numericKeys.includes(key) ? 'right' : 'left', width: columnWidths[key] || 'auto' }}
                    >
                      {numericKeys.includes(key) ? (
                        formatNumber(item[key])
                      ) : (
                        <div style={{ whiteSpace: 'pre-line' }}>
                          {item[key] ? String(item[key]).replace(/\r\n|\r|\n/g, '\n') : ''}
                        </div>
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: 'center', padding: '10px' }}>
                  Tidak ada data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}


export default LapJBM;
